import React from "react";
import { useRef } from "react";
import emailjs from "@emailjs/browser";
import { Snackbar } from "@mui/material";
import {
  ContactButton,
  ContactInputMessage,
  ContactInput,
  ContactTitle,
  ContactForm,
  Desc,
  Title,
  Container,
  Wrapper,
} from "./ContactStyle";

const Contact = () => {
  //hooks
  const [open, setOpen] = React.useState(false);
  const form = useRef();

  const handleSubmit = (e) => {
    e.preventDefault();
    emailjs
      .sendForm(
        "service_r5ecxck",
        "template_gbrl7i6",
        form.current,
        "uGvrQ5oh5Pa9d7SCI"
      )
      .then(
        (result) => {
          setOpen(true);
          form.current.reset();
        },
        (error) => {
          console.log(error.text);
        }
      );
  };

  return (
    <Container id="contact">
      <Wrapper>
        <Title>Contact</Title>
        <Desc>
          N'hésitez pas à me contacter pour toute question ou opportunité !
        </Desc>
        <ContactForm ref={form} onSubmit={handleSubmit}>
          <ContactTitle>Contactez-moi 🚀</ContactTitle>
          <ContactInput placeholder="Email" name="from_email" />
          <ContactInput placeholder="Nom" name="from_name" />
          <ContactInput placeholder="Sujet" name="subject" />
          <ContactInputMessage placeholder="Message" rows="4" name="message" />
          <ContactButton type="submit" value="Envoyer" />
        </ContactForm>
        <Snackbar
          open={open}
          autoHideDuration={6000}
          onClose={() => setOpen(false)}
          message="Email sent successfully!"
          severity="success"
        />
      </Wrapper>
    </Container>
  );
};

export default Contact;
